import * as Mithril from 'mithril';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Tooltip from 'flarum/common/components/Tooltip';
import avatar from 'flarum/common/helpers/avatar';
import Link from 'flarum/common/components/Link';
import type User from 'flarum/common/models/User';
import classList from 'flarum/common/utils/classList';

import Widget, { WidgetAttrs } from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

export default class BirthdayUsersWidget<T extends WidgetAttrs> extends Widget<T> {
  oninit(vnode: Mithril.VnodeDOM): void {
    super.oninit(vnode);

    this.loadWithInitialResponse = app.forum.attribute('afrux-forum-widgets-core.preferDataWithInitialLoad');
    this.attrs.state.users ??= [];
    this.attrs.state.isLoading ??= true;
    this.attrs.state.hasLoaded ??= false;
  }

  oncreate(vnode): void {
    super.oncreate(vnode);

    if (!this.attrs.state.hasLoaded) {
      setTimeout(this.load.bind(this), this.loadWithInitialResponse ? 0 : 300);
    }
  }

  view() {
    return (
      this.attrs.state.users.length > 0 && (
          <div className={classList(['AfruxWidgets-Widget', this.className()])}>
            {this.header()}
            <div className="AfruxWidgets-Widget-content">{this.content()}</div>
          </div>
      )
    );
  }

  className(): string {
    return 'Datlechin-BirthdayUsersWidget';
  }

  icon(): string {
    return 'fas fa-birthday-cake';
  }

  title() {
    return (
      <Link href={app.route('birthdays')}>
        {app.translator.trans('datlechin-birthdays.forum.widget.title')}
      </Link>
    );
  }

  content(): Mithril.Children {
    if (this.attrs.state.isLoading) {
      return <LoadingIndicator />;
    }

    const max = app.forum.attribute('afrux-online-users-widget.maxUsers') || 5;
    const users = this.attrs.state.users;

    return (
      <div className="Datlechin-BirthdayUsersWidget-users">
        <div className="Datlechin-BirthdayUsersWidget-users-message">
          {users.length === 0 ? app.translator.trans('datlechin-birthdays.forum.widget.empty') : null}
        </div>
        <div className="Datlechin-BirthdayUsersWidget-users-list">
          {users.slice(0, max).map((user: User) => (
            <Link href={app.route('user', { username: user.slug() })} className="Datlechin-BirthdayUsersWidget-users-item">
              <Tooltip text={user.displayName()}>{avatar(user)}</Tooltip>
            </Link>
          ))}
          {users.length > max ? (
            <span className="Datlechin-BirthdayUsersWidget-users-item Datlechin-BirthdayUsersWidget-users-item--plus">
              <span className="Avatar">{`+${max}`}</span>
            </span>
          ) : null}
        </div>
      </div>
    );
  }

  load(): void {
    if (this.loadWithInitialResponse) {
      const users = app.forum.birthdayUsers();
      this.setResults(users || []);
      return;
    }

    this.attrs.state.isLoading = true;

    const today = dayjs().format('YYYY-MM-DD');
    app.store.find('users', {
      filter: { birthday: today, },
    }).then((users: User[]) => {
      this.setResults(users);
    });
  }

  setResults(users) {
    this.attrs.state.users = users;
    this.attrs.state.isLoading = false;
    this.attrs.state.hasLoaded = true;
    m.redraw();
  }
}
